'use client';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import Link from '@alltrails/denali/components/Link';
import Modal from '@alltrails/modal/components/Modal/Modal';
import styles from './styles/LeadershipCard.module.scss';
import type { Leader } from './';

export default function OurLeadershipCard({ leader }: { leader: Leader }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.card}>
      {/* Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A11787&t=eucdQ5QfGXKB0ZUE-4 */}
      <Modal isOpen={isOpen} onCloseRequest={() => setIsOpen(false)}>
        <div className={styles.modal}>
          <Image alt="" src={leader.photo} className={styles.img} loading="lazy" />
          <Typography component="div" variant="heading400">
            {leader.name}
            <br />
            <span className={styles.title}>{leader.title}</span>
          </Typography>
          <Typography className={styles.bio} component="div" variant="paragraph100">
            {leader.bio}
          </Typography>
        </div>
      </Modal>
      <picture>
        <Image alt="" src={leader.photo} className={styles.img} loading="lazy" />
      </picture>
      <Heading as="h3" className={styles.name} size="300">
        {leader.name}
        <br />
        <span className={styles.title}>{leader.title}</span>
      </Heading>
      <div className={styles.linksContainer}>
        <Link className={styles.link} onClick={() => setIsOpen(true)}>
          <FormattedMessage defaultMessage="Full bio" />
        </Link>
        {leader.contact && (
          <Link className={styles.link} href={leader.contact} target="_blank">
            <FormattedMessage defaultMessage="Contact me" />
          </Link>
        )}
      </div>
    </div>
  );
}
